import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services/common.service';
import { TaskDetailComponent } from '../task-detail/task-detail.component';
import { APIService, isGalaxyFoldPhome } from '../../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TaskEntryComponent } from '../task-entry/task-entry.component'
import { DataService } from '../../services/data.service';
import { ModuleTrainingComponent } from '../../module-training/module-training.component';
import { Router, ActivatedRoute } from '@angular/router';
import { isNull, isNumber } from 'lodash';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit {

  inbox = this.commonService.GetParam('T');
  taskOpenNew = this.commonService.GetParam('n');
  taskID = this.commonService.GetParam('tid');
  StatusID: number = 0;
  delegateStatusID: number = 0;
  id: number = 0;
  jarvisData: any = [];
  agencyData: any = [];
  TskData: any = [];
  filterForMe: number = 0;
  filterDelegated : number = 0;
  finalTaskArr: any = [];
  checkFilterTasksType: any ;
  closeResult: any;
  modalReference: any;
  search : string = '';
  searchdelegated: string = '';
  viewTypeID: number = 0; // 0 -> Inbox, 1 -> Outbox
  @Input() mdlRef: any;
  curDate: any = new Date();
  months: any = [];
  month: any;
  year: any;
  yearList: any = [];
  selectedMonthName: any;
  view = {
    month: this.curDate.getMonth() + 1,
    year: this.curDate.getFullYear(),
    delegateMnth: this.curDate.getMonth() + 1
  }
  
  tskData : any = [];
  tskDlgtData : any = [];
  cookieTaskList : any = [];
  cookieDlgtTaskList : any = [];
  userList: any = [];
  
  taskDetailModal: any;
  selectedTags : any = [];
  taskEntryModal: any;
  isPageLoad: boolean = true;
  //isshowUser: boolean = false;

  isTaskRec: boolean = false;
  tableData: any = [];
  filter: any;
  UserID: number = 0;
  userLID: number = 0;
  CrtUserID: number = 0;
  actualTaskforMe: Array<any> = [];
  actualTaskforDelegate: Array<any> = [];
  isGalaxyFoldMobile: boolean = isGalaxyFoldPhome;
  createdName: any;
  isWeb: boolean = true;
  showLearningMaterial: boolean = false;
  showOnBoarding: boolean = false;

  constructor(private modalService: NgbModal,private commonService: CommonService, private apiService: APIService,private SpinnerService: NgxSpinnerService, private dataService: DataService, private route: ActivatedRoute, private router: Router) { }

  isShowTaskForMe: boolean = false;
  isShowDelegatedForMe : boolean = false;
  serachTasksforMe: boolean = false;
  isInboxShow = false
  isOutbox = false;
  isNewTask: boolean = false;
  isShowTask: boolean = false;
  projectList: Array<any> = [];  
  selectedTask: any;

  ngOnInit(): void {   
    if(this.inbox == 1){
      this.isInboxShow = true;
    }
    else if(this.inbox == 2){
      this.isOutbox = true;
    }
    else{
      this.isInboxShow = false
      this.isOutbox = false;
    }

    if(this.taskOpenNew == 1){
        this.taskEntryModel(1);
    }

    // get months list
    this.getMonYrData();
   
    this.month = this.view.month;
    this.year = this.view.year;

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
        this.agencyData = JSON.parse(agencyData);
    }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
      this.UserID = this.jarvisData[0].UserID;
    }

    let users = this.apiService.getCookie('J');
    if(users){
      this.userList = JSON.parse(users);
    }

    let TasksData = this.apiService.getCookie('tsk');  
    if (TasksData && TasksData != "null") {
      this.TskData = JSON.parse(TasksData);
    }
  
    this.isShowTask = this.agencyData[0].ETS ? this.agencyData[0].ETS : false;
    if(!this.isShowTask){
      window.location.href = "https://biziverse.com/main.html#/home";
    }

    this.isWeb = this.apiService.apiCheckWeb();
    this.showLearningMaterial = this.commonService.checkShowLearningMaterial();
    this.showOnBoarding = this.commonService.checkShowOnBoarding();

    this.getData();
  }

  //get Tasks Data
  getData() {
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");
    let LastTaskActiveDT = localStorage.getItem("tskDT");
    if(this.TskData.length == 0){
      LastTaskActiveDT = "";
    }
    let data = [{
      StatusID: this.viewTypeID == 0 ? this.StatusID : this.delegateStatusID,
      Year: this.year,
      Month: this.month,
      LastTaskActiveDT: LastTaskActiveDT ? new Date(LastTaskActiveDT) : "",
      type: this.viewTypeID
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 28,
      data: JSON.stringify(data)
    }];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successRespTsk.bind(this), this.failureRespTsk.bind(this));
  }

  //successConfigResp - success  get handler
  successRespTsk(res: any) {
    if((this.viewTypeID == 0 && (this.StatusID == 0 || this.StatusID == 1)) || 
             (this.viewTypeID == 1 && (this.delegateStatusID == 0 || this.delegateStatusID == 1))) {
        this.apiService.setCookie('tskDT', new Date());
    }

    this.SpinnerService.hide();    
    var cookieTaskData: any;
    let fullDataFortaskMe: Array<any> = [];
    let fullDataFortaskOther: Array<any> = [];
    if (res.error) {
      this.apiService.successAlert(res.message)
    }
    else {
      if (res) {   
        let reponseData: any = JSON.parse(res.updatePackage);
        if (reponseData) {          
          let tableLength = reponseData.Table1.length;
          let tblTask: Array<any> = reponseData.Table1;
          if (reponseData.Table2) {
            this.projectList = reponseData.Table2;
          }
          if((this.viewTypeID == 0 && (this.StatusID == 0 || this.StatusID == 1)) || 
             (this.viewTypeID == 1 && (this.delegateStatusID == 0 || this.delegateStatusID == 1))) {
            
              // Replace cookie with the Response
              this.apiService.setCookie('tsk',JSON.stringify(tblTask));
              cookieTaskData = tblTask;
              this.actualTaskforDelegate = tblTask;

              // if (tableLength > 0) {         
            //   var localStorageData: any = this.apiService.getCookie('tsk');
            //   if (localStorageData != null && localStorageData != "" && localStorageData != "null") {
            //       localStorageData = JSON.parse(localStorageData);
            //   }
            //   else {
            //     localStorageData = [];
            //   }
            
            //   for (let j = 0; j < tableLength; j++) {
               
            //     if(!tblTask[j].IsRemove){
            //       tblTask[j]["IsRemove"] = false;
            //     }               
            //       let currData = $.grep(localStorageData, function (o: any) { return o.TaskID == tblTask[j].TaskID });
            //       if(currData.length > 0  && (tblTask[j].IsRemove == 1 || tblTask[j].IsRemove == true)){
            //         let findIndexofLocalStorage = localStorageData.findIndex((x: any) => x.TaskID === tblTask[j].TaskID);
            //         if (findIndexofLocalStorage > -1) {
            //             localStorageData.splice(findIndexofLocalStorage, 1);
            //         }
            //       }
            //       else if (currData.length > 0) { 
            //           let findIndexofLocalStorage = localStorageData.findIndex((x: any) => x.TaskID === tblTask[j].TaskID);
            //           localStorageData[findIndexofLocalStorage] = tblTask[j];
            //       }
            //       else if (currData.length == 0) { 
            //           if(tblTask[j].StatusID == 0 || tblTask[j].StatusID == 1){
            //             localStorageData.push(tblTask[j]);
            //           }
            //       }
            //   }
  
            //   this.apiService.setCookie('tsk',JSON.stringify(localStorageData));
            //   cookieTaskData = this.apiService.getCookie('tsk');   
            //   cookieTaskData = JSON.parse(cookieTaskData);  
            //   for(let i = 0; i < cookieTaskData.length; i++){
            //     let findIndexofLocalStorage = tblTask.findIndex((x: any) => x.TaskID === cookieTaskData[i].TaskID);
            //     if(findIndexofLocalStorage < 0){
            //       tblTask.push(cookieTaskData[i]);
            //     }
            //   }
            // }
            // else{
            //   cookieTaskData = this.apiService.getCookie('tsk');  
            //   if(cookieTaskData){
            //     cookieTaskData = JSON.parse(cookieTaskData); 
            //   }
            //   else{
            //     cookieTaskData = [];
            //   }
            //   tblTask = cookieTaskData;
            // }
          }
          else{        
            cookieTaskData = tblTask;
            if(!cookieTaskData){
              cookieTaskData = [];
            }
          }

          if(cookieTaskData.length > 0){
            // for Me data
            // tblTask = JSON.parse(cookieTaskData);
            
            if (this.isPageLoad == false && this.viewTypeID == 1 && (this.delegateStatusID == 2 || this.delegateStatusID == 3)) {
               if(this.StatusID == 0 || this.StatusID == 1){
                this.tskData = [];  
               }         
            }
  
            if (this.isPageLoad == false && this.viewTypeID == 0 && (this.StatusID == 2 || this.StatusID == 3)) {
               if(this.delegateStatusID == 0 || this.delegateStatusID == 1){
                this.tskDlgtData = [];
               }
            }

            tblTask.forEach((element: any) => {
              let selectedUsers = this.userList.filter((x: any) => x.UserID == element.CreatedUserID);
              if(selectedUsers.length > 0){
                element.CreatedUserName = selectedUsers[0].Name;
              }
              else{
                element.CreatedUserName = '';
              }
              
              if(this.UserID == element.ToUserID ){
                if(new Date().customFormat("#DD#-#MMM#-#YY#") == new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#")){
                  element.color = 'orangeText';
                }
                else if(new Date(new Date().customFormat("#DD#-#MMM#-#YY#")) < new Date(new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#"))){
                  element.color = 'greenText';
                }
                else{
                  element.color = 'redText';
                }
                
                if(element.StatusID == this.StatusID){
                  this.tskData.push(element);   
                } 
                // this.tskData.push(element);
                
                if(element.StatusID == 0 || element.StatusID == 1){
                  fullDataFortaskMe.push(element);
                }                  
              }
              // for Delegated data
                else if((this.UserID != element.ToUserID) && (element.CreatedUserID != element.ToUserID)){             
                  if(new Date().customFormat("#DD#-#MMM#-#YY#") == new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#")){
                    element.color = 'orangeText';
                  }
                  else if(new Date(new Date().customFormat("#DD#-#MMM#-#YY#")) < new Date(new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#"))){
                    element.color = 'greenText';
                  }
                  else{
                    element.color = 'redText';
                  }
                  if(element.StatusID == this.delegateStatusID){
                    this.tskDlgtData.push(element);   
                  } 
                  
                  if(element.StatusID == 0 || element.StatusID == 1){
                    fullDataFortaskOther.push(element);
                  } 
                }
            });

            this.tskData = this.tskData.sort(
              (n1: any, n2: any) => +new Date(n1.ExpCompletionDT) - +new Date(n2.ExpCompletionDT)
                                       || n1.Priority - n2.Priority
            );

            this.tskDlgtData = this.tskDlgtData.sort(
              (n1: any, n2: any) => +new Date(n1.ExpCompletionDT) - +new Date(n2.ExpCompletionDT)
                                       || n1.Priority - n2.Priority
            );
          }

          // Inbox - Sort by Priority wise
          // this.tskData = this.tskData.sort((n1: any,n2: any) => {
          //     if (n1.Priority > n2.Priority) {
          //         return 1;
          //     }
          
          //     if (n1.Priority < n2.Priority) {
          //         return -1;
          //     }        
          //     return 0;
          // });

          fullDataFortaskMe = fullDataFortaskMe.sort(
            (n1: any, n2: any) => +new Date(n1.ExpCompletionDT) - +new Date(n2.ExpCompletionDT)
                                     || n1.Priority - n2.Priority
          );
          

        fullDataFortaskOther = fullDataFortaskOther.sort(
          (n1: any, n2: any) => +new Date(n1.ExpCompletionDT) - +new Date(n2.ExpCompletionDT)
                                   || n1.Priority - n2.Priority
        );


          if(this.isPageLoad || (this.viewTypeID == 0 && (this.isNewTask == true || this.StatusID == 0 || this.StatusID == 1))) {
            this.actualTaskforMe = fullDataFortaskMe; //this.tskData;
            this.tasksForMeFilter(this.StatusID);
            this.isNewTask = false;
          }
         
          if(this.isPageLoad || (this.viewTypeID == 1 && (this.isNewTask == true || this.delegateStatusID == 0 || this.delegateStatusID == 1))) {
            this.actualTaskforDelegate = fullDataFortaskOther;//this.tskDlgtData;
            this.delegatedTasksFilter(this.delegateStatusID);
            this.isNewTask = false;
          }

          
          if (this.isPageLoad == false && this.viewTypeID == 1 && (this.delegateStatusID == 2 || this.delegateStatusID == 3)) {
            if(this.StatusID == 0 || this.StatusID == 1){
              this.tasksForMeFilter(this.StatusID);
            }            
          }

          if (this.isPageLoad == false && this.viewTypeID == 0 && (this.StatusID == 2 || this.StatusID == 3)) {
            if(this.delegateStatusID == 0 || this.delegateStatusID == 1){
              this.delegatedTasksFilter(this.delegateStatusID);
            }
          }

          if (this.taskID && !isNull(this.taskID)) {
              let task = tblTask.find((t: any) => t.TaskID == this.taskID);
              if (task) {
                this.openTaskDetails(task);
              }
          }
        }
      }
      this.isPageLoad = false;
    }
  }

  //failureResp - failure handler
  failureRespTsk(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //get Tasks Details
  getTaskDetails(obj : any) {
    
    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");
    let data = [{
      taskID: obj.TaskID,
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get_tskDetails',
      moduleID: 28,
      data: JSON.stringify(data)
    }];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successRespTskDtl.bind(this), this.failureRespTsk.bind(this));
  }
  
  successRespTskDtl(res: any) {
    this.SpinnerService.hide(); 
    let reponseData: any = JSON.parse(res.updatePackage);
    if (reponseData) {   
      let tableLength = reponseData.Table1.length;
      let tblTaskdtl: Array<any> = reponseData.Table1;

      this.selectedTask.projectName = (tblTaskdtl && tableLength > 0) ? tblTaskdtl[0].Project : "";
      let projectStageList = (tblTaskdtl && tableLength > 0) ? JSON.parse(tblTaskdtl[0].ProjectStages) : [];
      let selectedProjectStage = $.grep(projectStageList, function (o: any) { return o.SID == tblTaskdtl[0].ProjectStageID });
      this.selectedTask.projectStageName = (selectedProjectStage && selectedProjectStage.length > 0) ? selectedProjectStage[0].SNm : "";
    }

    this.openTaskDetailsModel(this.selectedTask);
  }

  //filter Model Open
  openTaskFilter(content: any) {
        this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'filterTasks', backdrop: 'static', keyboard: false });
        this.modalReference.result.then((result: any) => {
          if (result) {

          }
        });
  }
        
  // filter
  tasksForMeFilter = (id: number) => {
    this.viewTypeID = 0;
    // this.tskData = [];
    this.filterForMe = id;
    this.cookieTaskList = this.actualTaskforMe;
    var taskList :any = []; 
    var taskFilter :any = [];
    // get months list
    // this.getMonYrData();
    this.month = this.view.month;
    this.year = this.view.year;
      if (id == 0){
        this.StatusID = id;
        // this.getData();
        if(this.cookieTaskList.length > 0){
        taskList = this.cookieTaskList
        
        taskFilter = taskList.filter(function (element: any, index: any) {
          return (element.StatusID == id);
        });
        }
      }
      else if (id == 1){
        this.StatusID = id;
        // this.getData();
        if(this.cookieTaskList.length > 0){
          taskList = this.cookieTaskList;
          taskFilter = taskList.filter(function (element: any, index: any) {
            return (element.StatusID == id);
          });
        }
      }
      else if(id == 2){
        this.viewTypeID = 0;
        this.StatusID = id;
        this.changeMonth();
        // if(this.cookieTaskList.length > 0){
        //   taskList = this.cookieTaskList;
        //   taskFilter = taskList.filter(function (element: any, index: any) {
        //     return (element.StatusID == id);
        //   });
        // }
      }
      else if(id == 3){        
        this.viewTypeID = 0;
        this.StatusID = id;
        this.changeMonth();
        // if(this.cookieTaskList.length > 0){
        //   taskList = this.cookieTaskList;
        //   taskFilter = taskList.filter(function (element: any, index: any) {
        //     return (element.StatusID == id);
        //   });
        // }
      }
      if(taskFilter){
      this.tskData = taskFilter;  
      this.tskData.forEach((element: any) => {
        if(new Date().customFormat("#DD#-#MMM#-#YY#") == new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#")){
          element.color = 'orangeText';
        }
        else if(new Date(new Date().customFormat("#DD#-#MMM#-#YY#")) < new Date(new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#"))){
          element.color = 'greenText';
        }
        else{
          element.color = 'redText';
        }
      });
    }
    // else{
    //   this.tskData = [];
    // }
  }

  // filter
  delegatedTasksFilter = (id: number) => {
    this.viewTypeID = 1;
    this.tskDlgtData = [];
    this.filterDelegated = id;
    this.cookieDlgtTaskList = this.actualTaskforDelegate;
    var taskList: Array<any> = []; 
    var dlgttaskFilter :any; 
    this.viewTypeID = 1;
    // get months list
    // this.getMonYrData();
    this.month = this.view.month;
    this.year = this.view.year;

      if (id == 0){
      this.delegateStatusID = id;
        if(this.cookieDlgtTaskList.length > 0){
        taskList = this.cookieDlgtTaskList;
        
        dlgttaskFilter = taskList.filter(function (element: any, index: any) {
            return (element.StatusID == id);
          });
        }
      }
      else if (id == 1) {
        this.delegateStatusID = id;
          if(this.cookieDlgtTaskList.length > 0){
            taskList = this.cookieDlgtTaskList;
            dlgttaskFilter = taskList.filter(function (element: any, index: any) {
              return (element.StatusID == id);
            });
          }
      }
      else if(id == 2){
        this.delegateStatusID = id;
        this.viewTypeID = 1;
        this.changeDelegateMonth();
        // if(this.cookieTaskList.length > 0){
        //   taskList = this.cookieDlgtTaskList;
        //   dlgttaskFilter = taskList.filter(function (element: any, index: any) {
        //     return (element.StatusID == id);
        //   });
        // }
      }
      else if(id == 3){
        this.delegateStatusID = id;
        this.viewTypeID = 1;
        this.changeDelegateMonth();
        // if(this.cookieTaskList.length > 0){
        //   taskList = this.cookieDlgtTaskList;
        //   dlgttaskFilter = taskList.filter(function (element: any, index: any) {
        //     return (element.StatusID == id);
        //   });
        // }
      }

      if(dlgttaskFilter){
        this.tskDlgtData = dlgttaskFilter;  
        this.tskDlgtData.forEach((element: any) => {
          if(new Date().customFormat("#DD#-#MMM#-#YY#") == new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#")){
            element.color = 'orangeText';
          }
          else if(new Date(new Date().customFormat("#DD#-#MMM#-#YY#")) < new Date(new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#"))){
            element.color = 'greenText';
          }
          else{
            element.color = 'redText';
          }
        });
      }
      else{
        this.tskDlgtData = [];
      }
  }

  //get Months and year
  getMonYrData() {
    this.months = this.commonService.getMonthYear(new Date('2020-10-01'), new Date());
    if(this.months.length > 0){
      this.view.month = this.months[this.months.length - 1].id + "";
      this.view.delegateMnth = this.months[this.months.length - 1].id + "";
    }
  }

  // edit Tasks Model Open
  openTaskDetails(obj: any){
    this.selectedTask = obj;
    if (obj.StatusID == 3) {
      this.getTaskDetails(obj);
      return;
    }

    this.openTaskDetailsModel(obj);
  }

  openTaskDetailsModel(obj: any) {
    this.taskDetailModal = this.modalService.open(TaskDetailComponent, {windowClass: 'TaskDetailComponent',backdrop: 'static', size: 'md', keyboard: false});
    this.taskDetailModal.componentInstance.mdlRef = this.taskDetailModal;
    this.taskDetailModal.componentInstance.taskData = obj;

    if (obj.StatusID != 3) {
      if(obj.ProjectID && obj.ProjectStageID)
        {
          let tempList = $.grep(this.projectList, function (o: any) { return o.JobID == obj.ProjectID });
          obj.projectName = (tempList && tempList.length > 0) ? tempList[0].JobNo : "";
          let projectStageList = (tempList && tempList.length > 0) ? JSON.parse(tempList[0].Stages) : [];
          let selectedProjectStage = $.grep(projectStageList, function (o: any) { return o.SID == obj.ProjectStageID });
          obj.projectStageName = (selectedProjectStage && selectedProjectStage.length > 0) ? selectedProjectStage[0].SNm : "";
        }
    }
    
    if (obj.ToUserID == this.jarvisData[0].UserID) {
      this.viewTypeID = 0;
    }
    else if(obj.ToUserID != this.jarvisData[0].UserID && obj.ToUserID != obj.CreatedUserID){
      this.viewTypeID = 1;
    }
    this.taskDetailModal.result.then((result: any) => {
      if (result == 'Done') {
        this.tskDlgtData = [];
        this.tskData = [];       
        if(this.viewTypeID == 1 && (this.delegateStatusID == 3 || this.delegateStatusID == 2) ||
            (this.viewTypeID == 0 && (this.StatusID == 3 || this.StatusID == 2))){
          var localStorageData: any = this.apiService.getCookie('tsk');
          if (localStorageData != null && localStorageData != "" && localStorageData != "null") {
              localStorageData = JSON.parse(localStorageData);
          }
          else {
            localStorageData = [];
          }
          obj.StatusID = 0;
          localStorageData.push(obj);
          this.apiService.setCookie('tsk',JSON.stringify(localStorageData));
          if (this.viewTypeID == 0 && (this.StatusID == 3 || this.StatusID == 2)) {
            this.actualTaskforMe.push(obj);
          }
          else if(this.viewTypeID == 1 && (this.delegateStatusID == 3 || this.delegateStatusID == 2)){
            this.actualTaskforDelegate.push(obj);
          }
        }
        this.getData();
      }
    });
  }

  //  Tasks Entry Model Open
  taskEntryModel(id: number){
  this.taskEntryModal = this.modalService.open(TaskEntryComponent, {windowClass: 'TaskEntryComponent', backdrop: 'static', size: 'md', keyboard: false});
  this.taskEntryModal.componentInstance.mdlRef = this.taskEntryModal;
  this.taskEntryModal.componentInstance.projectList = this.projectList;
  this.taskEntryModal.result.then((result: any) => {
    if (result == 'Done') {
      this.tskDlgtData = [];
      this.tskData = [];      
      this.isNewTask = true;
      this.getData();
    }
    });
    if(id == 1){
      this.taskEntryModal.componentInstance.modalHeader = "Create Task";
      this.viewTypeID = 0;
    }
    else {
      this.taskEntryModal.componentInstance.modalHeader = "Create Task";
      this.viewTypeID = 1;
    }
  }

  //close model
  closeModel(){
    this.modalReference.close('Close');
  }

  changeMonth(){
    let selectedMnthID = this.view.month;
    let selectedMonth: any = this.months.filter((o: any) => o.id == selectedMnthID);
    this.month = selectedMonth[0].number;
    this.year = selectedMonth[0].year;
    this.viewTypeID = 0;
    this.tskData = [];
    this.getData();
  }

  changeDelegateMonth(){
    let selectedMnthIDDele = this.view.delegateMnth;
    let selectedMonth: any = this.months.filter((o: any) => o.id == selectedMnthIDDele);
    this.month = selectedMonth[0].number;
    this.year = selectedMonth[0].year;
    this.tskDlgtData = [];
    this.viewTypeID = 1;
    this.getData();
  }

  backToHomeBtn() {
    this.SpinnerService.show();
    window.location.href = "https://biziverse.com/main.html#/home";
  }

  clearSearch(){
    this.search = '';
  }

  clearSearchForDele(){
    this.searchdelegated = '';
  }

  //#region "Reminder"

  //sendReminder() - Send Reminder for Task Status
  sendReminder(obj: any){
    console.log(obj);
    let toUsers = this.userList.filter((x: any) => x.UserID == obj.ToUserID);
    let senders = this.userList.filter((x: any) => x.UserID == this.jarvisData[0].UserID);
    let tempData: Array<any> = [{
      TaskID: obj.TaskID,
      Task: obj.Task,
      Detail: obj.Detail,
      TaskReceiverEmail: toUsers[0].Email,
      TaskCreatorEmail: senders[0].Email,
      TaskCreatoerName: senders[0].Name,
      TaskReceiverName: obj.ToUserName
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'sendReminder',
      moduleID: 28,
      data: JSON.stringify(tempData)
  }];

    this.apiService.swalConfirm("Would you like to remind " + obj.ToUserName + " about the task #" + obj.TaskID + "?", () => {
      this.apiService.sendChange(myParams, this.successSendReminder.bind(this), this.failureResp.bind(this));
    });
  }

  //saveSendRemonder() - Reminder send to Propgation
  successSendReminder(res: any){
    this.apiService.successAlert("Reminder sent.");
  }

  failureResp(res: any){
    console.log(Error, res);
  }
  redirectTaskReport(){
    this.SpinnerService.show();
    window.location.href = "/ERP/TaskRpt";
  }

  redirectAllTaskReport() {
    this.SpinnerService.show();
    this.router.navigate(['/RptOrgTasks']);
  }

  checkAllTaskAccess() {
    // Function to get cookie from localStorage
    function getLocalStorageCookie(name: string) {
      try {
        const value = localStorage.getItem(name);
        return value ? JSON.parse(value) : null;
      } catch (e) {
        console.error('Error getting cookie from localStorage:', e);
        return null;
      }
    }

    // Get M cookie from localStorage
    const mCookie = getLocalStorageCookie('M');
    if (!mCookie || !Array.isArray(mCookie)) return false;

    // Extract showAllTaskBit from M cookie
    const showAllTaskBit = mCookie[0]?.AllowOrgTasks || false;
    if (!showAllTaskBit) return false;

    // Extract UserID and AdminUserID from M cookie
    const currentUserID = this.jarvisData[0]?.UserID;
    const adminUserID = mCookie[0]?.AdminUserID;

    // Check if user is admin
    const isAdmin = currentUserID === adminUserID;

    // Get J cookie from localStorage
    const jCookie = getLocalStorageCookie('J');
    if (!jCookie || !Array.isArray(jCookie)) return false;

    // Find current user in J cookie
    const currentUser = jCookie.find(user => user.UserID === currentUserID);
    if (!currentUser) return false;

    // Check if user is super user (has all CRM, B2B, and ERP rights)
    const isSuperUser = (currentUser.PropEntry && currentUser.PropEdit && currentUser.CstrEntry && currentUser.CstrEdit && currentUser.QuoteEntry && currentUser.QuoteEdit && currentUser.ApprQot && currentUser.SOEntry && currentUser.SOEdit && currentUser.ApprSO && currentUser.SOStatusUpdate && currentUser.InvoiceEntry && currentUser.InvoiceEdit && currentUser.ApprInv && currentUser.CtrcEntry && currentUser.CtrcEdit && currentUser.CtrcStatusUpdates && currentUser.PropViewTypeID === 1 && currentUser.CstrViewTypeID === 1 && currentUser.InvoiceView && currentUser.ConnEntry && currentUser.FeedEntry && currentUser.Accts && currentUser.AcctsVchrEntry && currentUser.AcctsCfg && currentUser.Inv && currentUser.InvXns && currentUser.InvMstrs && currentUser.InvRpts && currentUser.InvCfg && currentUser.Prd && currentUser.PrdRpts && currentUser.PrdCfg && currentUser.SplrEntry && currentUser.SplrEdit && currentUser.POEntry && currentUser.POView && currentUser.ApprPurch && currentUser.InvRateView && currentUser.SplrInvoiceViewTypeID && currentUser.SplrInvoiceEntry && currentUser.SplrInvoiceEdit);

    // Return true if showAllTaskBit is true AND (user is admin OR user is super user)
    return showAllTaskBit && (isAdmin || isSuperUser);
  }

  // Open Help Page
  openHelpPage(id: any) {
    this.commonService.openModulHelp(id, this.isWeb);
  }
  //#endregion
  openTrngModal = () => {
    this.dataService.trainingVideoActions('active', 14);
    this.modalReference = this.modalService.open(ModuleTrainingComponent, { windowClass: "modal-suggest-profile", backdrop: 'static', keyboard: false });
  }
}
